import script from "./ActualidadList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActualidadList.vue?vue&type=script&setup=true&lang=js"

import "./ActualidadList.vue?vue&type=style&index=0&id=65e0f36f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e0f36f"]])

export default __exports__